import './page-okompanuu.css';

import Container from '../../@common.blocks/Container';
import Title from '../../@common.blocks/Title';
import Text from '../../@common.blocks/Text';
import Ryki from '../../pictures/ryki.svg';

const PageOKompanuu = () => {
  return (
    <>
      <Container>
        <div className="page-okompanuu">
          <div className="page-okompanuu__wrapper">
            <Title level="2" component="message">
              О компании
            </Title>
            <Text component="p" section="dostavka">
              Компания DinaxSystems предлагает полный спектр электромонтажных
              услуг, а так же услуги проектирования и программирования ПЛК для
              автоматизации технологических процессов. Наши решения призваны
              сокращать расход ресурсов и налаживать эффективное управление
              электрооборудованием на любых объектах инфраструктуры. Своим
              партнерам мы предлагаем выгодные экономические условия, гибкую
              систему скидок. Мы можем предложить готовые решения по
              проектированию и монтажу для наших клиентов, что значительно
              ускорит производство и ввод в эксплуатацию проекта. Наши
              специалисты всегда найдут индивидуальный подход к каждому клиенту.
              Мы руководствуемся принципом рациональной автоматизации, поэтому
              наша цель, реализация технических решений, как по автоматизации
              отдельных технологических процессов, так и комплексных систем,
              приносящих предприятиям прибыль.
            </Text>
            <div className="page-okompanuu__wrapper-img">
              <img src={Ryki} alt="" />
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};
export default PageOKompanuu;
